import React from "react";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import App from "./App";
import { loadConfig } from "./config";
import "./index.css";

async function bootstrap() {
  const config = await loadConfig();

  // Configure Amplify with Cognito using runtime config
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: {
          oauth: {
            domain: config.cognitoDomain,
            scopes: ["openid", "email", "profile"],
            redirectSignIn: [window.location.origin + "/callback"],
            redirectSignOut: [window.location.origin + "/"],
            responseType: "code",
            providers: [{ custom: config.idpProviderName }],
          },
        },
      },
    },
  });

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap().catch((err) => {
  console.error("Failed to initialize app:", err);
  document.getElementById("root")!.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;min-height:100vh;font-family:system-ui;">
      <div style="text-align:center;max-width:500px;padding:2rem;">
        <h1 style="color:#e53e3e;">Configuration Error</h1>
        <p>Could not load application configuration. Please ensure <code>env-config.json</code> has been generated.</p>
        <pre style="text-align:left;background:#f7f7f7;padding:1rem;border-radius:8px;overflow:auto;">${err.message}</pre>
      </div>
    </div>
  `;
});
